import { create } from "zustand";
import type { KpiDependencyConflict } from "@features/admin/kpi/types/kpiDependencyConflict";

interface ErrorModalState {
  validationErrors: string[] | null;
  kpiConflict: KpiDependencyConflict | null;
  systemError: string | null;
  showValidation: (errors: string[]) => void;
  showKpiConflict: (conflict: KpiDependencyConflict) => void;
  showSystem: (message?: string) => void;
  dismiss: () => void;
}

export const useErrorModalStore = create<ErrorModalState>()((set) => ({
  validationErrors: null,
  kpiConflict: null,
  systemError: null,
  showValidation: (errors) =>
    set({ validationErrors: errors, kpiConflict: null, systemError: null }),
  showKpiConflict: (conflict) =>
    set({ kpiConflict: conflict, validationErrors: null, systemError: null }),
  showSystem: (message) =>
    set({
      systemError: message || "An unexpected error occurred. Please try again later.",
      validationErrors: null,
      kpiConflict: null,
    }),
  dismiss: () => set({ validationErrors: null, kpiConflict: null, systemError: null }),
}));

/** True when a global error modal is shown over the current screen. */
export function selectGlobalErrorOpen(state: ErrorModalState): boolean {
  return state.kpiConflict != null || state.validationErrors != null || state.systemError != null;
}
